var map = {
	"./0.png": "c02a",
	"./1.58.png": "b22a",
	"./1.88.png": "c1d1",
	"./18.8.png": "9250",
	"./18.88.png": "3bb5",
	"./5.88.png": "676d",
	"./8.88.png": "d992",
	"./88.png": "9c5e",
	"./888.png": "b631",
	"./award.png": "388e",
	"./bg1.png": "45cc",
	"./bg2.png": "65f9",
	"./btn.png": "980f",
	"./btn1.png": "75cf",
	"./btn3.png": "b4de",
	"./close.png": "b854",
	"./cp.png": "f722",
	"./empty.png": "6d6c",
	"./hand.png": "f9c1",
	"./pbg.png": "6cfe",
	"./ptop.png": "7d90",
	"./record1.png": "6f34",
	"./rule.png": "5ccd",
	"./rule1.png": "1c61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28ae";